(function () {
  angular.module('app.widgets.products.product-segment-usage').component('appProductSegmentUsage', {
    bindings: {
      consumableUsageDataAvailable: '<?',
      customer: '<?',
      customerHasLegacyDeviceLicenses: '<?',
      customerHasSharedDeviceLicenses: '<?',
      customerSegment: '@?',
      eligibleForDeviceLicenses: '<?',
      productUsage: '<?',
      refreshCustomer: '&?',
      variant: '@?',
    },
    controller,
    templateUrl: 'app/widgets/products/segment-usage/product-segment-usage.component.html',
  });

  /* @ngInject */
  function controller(_, ConsumableUsageModal, LicenseDelegationDetailModal, User) {
    const vm = this;
    _.assign(vm, {
      $onInit,
      showConsumableUsageModal,
      showLicenseDelegationDetailModal,
    });

    function $onInit() {
      _.assign(vm, {
        isWide: vm.variant === 'wide',
        isWideTeam: vm.customerSegment === 'TEAM' && vm.variant === 'wide',
        lowerCaseCustomerSegment: _.toLower(vm.customerSegment),
        User,
      });
    }

    function showConsumableUsageModal(fulfillableItem, consumableItem) {
      ConsumableUsageModal.create({
        consumableItem,
        fulfillableItem,
      });
    }

    function showLicenseDelegationDetailModal() {
      LicenseDelegationDetailModal.create({
        consumableUsageDataAvailable: vm.consumableUsageDataAvailable,
        customerSegment: vm.customerSegment,
        productUsage: vm.productUsage,
      });
    }
  }
})();
